import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <header className="bg-gradient-to-r from-gray-800 to-gray-900 shadow-md">
      <div className="container mx-auto px-4 py-5 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="group">
            <span className="text-2xl md:text-3xl font-extrabold bg-gradient-to-r from-red-500 via-red-600 to-gray-200 bg-clip-text text-transparent filter drop-shadow-sm hover:from-red-400 hover:to-gray-300 transition-all duration-300 tracking-tight">
              Ultimate Directory
            </span>
          </Link>
        </div>
        
        <div className="flex items-center space-x-5">
          {currentUser ? (
            <>
              <Link 
                to="/dashboard"
                className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-red-400 transition-colors rounded-md"
              >
                Dashboard
              </Link>
              <button
                onClick={handleLogout}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md shadow-sm transition-colors"
              >
                Log Out
              </button>
            </>
          ) : (
            <>
              <Link 
                to="/login"
                className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-red-400 transition-colors rounded-md"
              >
                Log In
              </Link>
              <Link 
                to="/signup" 
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md shadow-sm transition-colors"
              >
                Join
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
